// extracted by mini-css-extract-plugin
export var range = "slider-module--range--5wURf";
export var root = "slider-module--root--1TKQP";
export var thumb = "slider-module--thumb--vUqru";
export var track = "slider-module--track--fLFpT";